__turbopack_context__.v({
  "primary": "MoneyPageTemplate-module__xW2JtG__primary",
  "tabHeader": "MoneyPageTemplate-module__xW2JtG__tabHeader",
  "wrapper": "MoneyPageTemplate-module__xW2JtG__wrapper",
});
